import React from "react";

import { Button } from "reactstrap";
import { Helmet } from "react-helmet";

import NavbarPrimary from "../sections/NavbarPrimary.js";
import HeaderHome from "../headers/HeaderHome.js";
import IntelMain from "../blogs/IntelMain.js";
import FeatureHome from "../sections/FeatureHome.js";
import Footer from "../sections/Footer.js";
import PreFooter from "../sections/PreFooter.js";
import CarouselConstant from "../accordions/CarouselConstant.js";

function Index() {
  React.useEffect(() => {
    document.body.classList.add("index");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (
      window.location.href.lastIndexOf("#") > 0 &&
      document.getElementById(href)
    ) {
      document.getElementById(href).scrollIntoView();
    }
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <Helmet>
        <title>CrypTegridy - Home</title>
        <meta name="description" content="Welcome to CrypTegridy. We specialize in leveraging human intelligence to protect you from malicious activities." />
        <meta name="keywords" content="CrypTegridy, security, protection, intelligence" />
      </Helmet>
      <NavbarPrimary />
      <div className="wrapper">
        <Button
          className="btn-icon-only back-to-top text-lowercase text-default show"
          color="info"
          name="button"
          type="button"
          onClick={() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
          }}
        >
          &alpha;
        </Button>
        <HeaderHome />
        <FeatureHome />
        <IntelMain />
        <CarouselConstant />
        <PreFooter />
        <Footer />
      </div>
    </>
  );
}

export default Index;
